import React from 'react';
import { useParams } from 'react-router-dom';
import ConversationView from '../../../pages/ConversationView';

const AIConversationView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  
  return <ConversationView />;
};

export default AIConversationView;